import React, { useState } from "react";

interface ContactInfoProps {
  label: string;
  name?: string;
  phone?: string | null;
}

const ContactInfo: React.FC<ContactInfoProps> = ({ label, name, phone }) => {
  const [showPhone, setShowPhone] = useState(false);

  const arrowStyle: React.CSSProperties = {
    transition: "transform 0.3s ease",
    transform: showPhone ? "rotate(180deg)" : "rotate(0deg)",
  };

  return (
    <div className="relative">
      <span>
        {label} {name || "tbd"}
      </span>
      {name && phone && (
        <button
          onClick={() => setShowPhone(!showPhone)}
          className="ml-2 text-blue-500"
          style={arrowStyle}
        >
          ▼
        </button>
      )}
      {showPhone && name && phone && (
        <p className="mb-1 text-sm text-gray-300">
          Phone: {phone || "No phone number available."}
        </p>
      )}
    </div>
  );
};

export default ContactInfo;
